export default __webpack_public_path__ + "static/media/team-mosaic-01.98989bbb.jpg";